import { IAnimMediaControl } from '../anim-interface';
import { MEDIA } from '../anim-constants';
import { RegionType } from '@src/slide/domain/selection/constant/region';
import PlayerAnimVideoControl from './player-anim-video-control';
import PlayerAnimAudioControl from './player-anim-audio-control';
import EditorAnimVideoControl from './editor-anim-video-control';
import EditorAnimAudioControl from './editor-anim-audio-control';
import type { IMediaManager } from '@src/slide/application/service/media-manager/media-manager.interface';

export default class AnimMediaControlFactory {
    private static mediaManager: IMediaManager;

    public static setMediaManagerDelegate(mediaManager: IMediaManager): void {
        if (AnimMediaControlFactory.mediaManager) return;
        AnimMediaControlFactory.mediaManager = mediaManager;
    }

    public static getInstance(region: string, type: string): IAnimMediaControl | undefined {
        const controlMap = {
            [RegionType.PLAYER]: {
                [MEDIA.VIDEO]: PlayerAnimVideoControl.getInstance(AnimMediaControlFactory.mediaManager),
                [MEDIA.AUDIO]: PlayerAnimAudioControl.getInstance(AnimMediaControlFactory.mediaManager),
            },

            [RegionType.EDITOR]: {
                [MEDIA.VIDEO]: EditorAnimVideoControl.getInstance(AnimMediaControlFactory.mediaManager),
                [MEDIA.AUDIO]: EditorAnimAudioControl.getInstance(AnimMediaControlFactory.mediaManager),
            },
        };

        return controlMap[region]?.[type];
    }
}
